import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AttributionProvider } from "./context/AttributionContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import FAQsPage from "./pages/FAQsPage";
import PrivacyPage from "./pages/PrivacyPage";
import FreeDesignTermsPage from "./pages/FreeDesignTermsPage";
import CookiesPage from "./pages/CookiesPage";

export default function App() {
    return (
        <BrowserRouter>
            <AttributionProvider>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/faqs" element={<FAQsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/free-design-terms" element={<FreeDesignTermsPage />} />
                        <Route path="/cookies" element={<CookiesPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </AttributionProvider>
        </BrowserRouter>
    );
}
